const config = {
  hostUrl: process.env.REACT_APP_HOST_URL,

  apiControlUrl: (version = Number(process.env.REACT_APP_API_VERSION) || 1): string => {
    return `${process.env.REACT_APP_HOST_URL}/api/v${version}`;
  },

  apiUrl: (version = Number(process.env.REACT_APP_API_VERSION) || 1): string => {
    return `${process.env.REACT_APP_HOST_URL}${process.env.REACT_APP_API_LOCATION}/v${version}`;
  },

  clientId: process.env.REACT_APP_CLIENT_ID,
  clientSecret: process.env.REACT_APP_CLIENT_SECRET,

  accessTokenKey: "access_token",
  refreshTokenKey: "refresh_token",
  rememberMeKey: "remember_me",
};

export default config;
